import React from 'react';
import cssmodules from 'react-css-modules';
import styles from './notificationwell.cssmodule.scss';
import { Link } from 'react-router';


class NotificationWell extends React.Component {



  render() {
    const { hasInitiative } = this.props;
    const { hasCIP } = this.props;

    return (
      <div className="notificationwell-component row" styleName="notificationwell-component">
        <div className="col-lg-12" style={{ paddingLeft: '0px', paddingRight: '0px' }}>
          <div className="well text-center" styleName={this.props.notificationType}>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

NotificationWell.displayName = 'NotificationWell';
NotificationWell.propTypes = {};
NotificationWell.defaultProps = { notificationType: 'error' };

export default cssmodules(NotificationWell, styles);



// WEBPACK FOOTER //
// ./components/Home/NotificationWell.js